module.exports = __webpack_public_path__ + "img/Webshop-online.67b00156.svg";